import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { Typography } from '@cp/ds/src/components/typography';
import { TranslationGroup } from '@common/model/resource/translationGroup';
import { TranslationMnemonic } from '@common/model/resource/translationMnemonic';
import { SxProps } from '@cp/ds';
import { useTranslations } from 'src/shared/translation';

export const CatalogItemPrice: React.FC<{ data: CatalogItemViewModel; sx?: SxProps }> = ({ data, sx }) => {
  const theme = useTheme();
  const [getCatalogTranslation] = useTranslations(TranslationGroup.Catalog);

  const priceValue =
    data.tariffs?.reduce((acc, t) => (acc && acc?.childrenCount < t.childrenCount ? acc : t), data.tariffs?.[0])?.price ?? data.price;

  const price =
    typeof priceValue === 'number' ? `${priceValue} ₽/час` : getCatalogTranslation(TranslationMnemonic.CatalogItemPriceNotSetLabel);

  return (
    <Box
      sx={{
        px: 1,
        py: 0.25,
        borderRadius: '6px',
        backgroundColor: theme.palette['brand gray'],
        color: theme.palette.white,
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Typography sx={{ whiteSpace: 'nowrap' }} variant="small text bold">
        {price}
      </Typography>
    </Box>
  );
};
